const SideNavLinks = [
  {
    text: 'Home',
    link: '/',
  },
  {
    text: 'About us',
    link: '/about',
  },
  {
    text: 'Executive Team',
    link: '/team',
  },
  {
    text: 'Employers',
    link: '/employers',
  },
  {
    text: 'Candidates',
    link: '/candidates',
  },
  {
    text: 'Library',
    link: '/library',
  },
  {
    text: 'Contact',
    link: '/contact',
  },
];

export default SideNavLinks;
